import React from 'react'
import { Checkbox } from 'shared-components'
import RegisterContent from '../../../content/register'
import { UserInformationObject } from '../Register'
import { FormButton } from './FormButton'

const { termsAcceptForm } = RegisterContent

export type TermsSelection = {
  termsAccepted: boolean
  electronicCommunicationAccepted: boolean
  newsletterSubscribed: boolean
}

const TermsAcceptForm = ({
  goToPreviousStep,
  registerUser,
  updateSelection,
  userInformation,
}: {
  goToPreviousStep: () => void
  updateSelection: (selectedTerms: TermsSelection) => void
  registerUser: () => void
  userInformation: UserInformationObject
}) => {
  return (
    <form
      name="TermsAcceptForm"
      onSubmit={(e) => {
        e.preventDefault()
        registerUser()
      }}
      data-testid="terms-accept-form"
      autoComplete="off"
    >
      <div className="mb-5 mt-6">
        <Checkbox
          testId="terms-checkbox"
          isChecked={userInformation.termsAccepted}
          fieldName={'Terms'}
          label={termsAcceptForm.terms}
          onChange={(value: boolean) =>
            updateSelection({
              ...userInformation,
              termsAccepted: value,
            })
          }
        />
      </div>
      <div className="mb-5">
        <Checkbox
          testId="electronic-communication-checkbox"
          isChecked={userInformation.electronicCommunicationAccepted}
          fieldName={'Electronic Communication'}
          label={termsAcceptForm.electronicCommunication}
          onChange={(value: boolean) =>
            updateSelection({
              ...userInformation,
              electronicCommunicationAccepted: value,
            })
          }
        />
      </div>
      <div className="mb-5">
        <Checkbox
          testId="newsletter-checkbox"
          isChecked={userInformation.newsletterSubscribed}
          fieldName={'Newsletter Subscribe'}
          label={termsAcceptForm.newsletterSubscribe}
          onChange={(value: boolean) =>
            updateSelection({
              ...userInformation,
              newsletterSubscribed: value,
            })
          }
        />
      </div>
      <p className="text-center text-2026-form-gray-light text-sm mb-6">
        *Required
      </p>

      <div className="w-[330px] mx-auto">
        <FormButton
          type="submit"
          disabled={
            !userInformation.electronicCommunicationAccepted ||
            !userInformation.termsAccepted
          }
        >
          {termsAcceptForm.registerButtonLabel}
        </FormButton>
        <FormButton
          variant="secondary"
          type="button"
          onClick={() => goToPreviousStep()}
        >
          {termsAcceptForm.backButtonLabel}
        </FormButton>
      </div>
    </form>
  )
}

export default TermsAcceptForm
